import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Empty } from "antd";
import { PageHeader } from "../components/PageHeader";
import { NavCards } from "../components/NavCards";
import { useUser } from "../context/UserContext";
import { findModule, visibleItems } from "../helpers/nav";

// One generic hub for every multi-page module — the second level of the card navigation.
export default function ModulePage() {
  const { moduleKey } = useParams();
  const { user } = useUser();
  const mod = findModule(moduleKey);
  const items = useMemo(() => (mod ? visibleItems(mod, user) : []), [mod, user]);

  if (!mod) return <Navigate to="/" replace />;
  if (mod.path) return <Navigate to={mod.path} replace />;

  return (
    <div>
      <PageHeader title={mod.label} subtitle={mod.description} />
      {items.length === 0 ? <Empty description="Nothing here you have access to." /> : <NavCards cards={items} />}
    </div>
  );
}
